// 事件监听
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

// 事件注销
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

export const writeMetaDescription = (des) => {
  // 获取 <meta> 元素
  let metaDescription = document.querySelector('meta[name="description"]');

  // 检查是否找到了对应的 <meta> 元素
  if (metaDescription) {
    // 修改 content 属性的值
    metaDescription.setAttribute('content', des);
  } else {
    // 如果没有找到对应的 <meta> 元素，可以创建一个并添加到 <head> 中
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = des;
    document.head.appendChild(metaDescription);
  }
};

